export default "__VITE_ASSET__D5$KKv0Q__"